@import (reference) '../../../../constants/spacing.module.less';

.productCard {
  background: var(--white);
  border: 1px solid var(--grey-300);
  border-radius: 8px;
  padding: @space-16;
  transition: box-shadow 0.2s ease;
  height: 100%;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.cardContent {
  height: 100%;
  max-height: 100%;
  min-height: 0;
  align-items: center;
}

.productImage {
  width: 96px;
  height: 96px;
  object-fit: cover;
  border-radius: 4px;
  background: var(--grey-100);
  flex: 0 0 auto;
}

.productName {
  flex: 1 1 auto;
  margin: 0;
  text-align: center;
  align-content: center;
}

.discountBadge {
  background: var(--red-600);
  color: var(--white);
  font-weight: 600;
  padding: @space-2 @space-8;
  border-radius: 4px;
  align-self: center;
}

.discountBadgePlaceholder {
  font-weight: 600;
  padding: @space-2 @space-8;
  align-self: center;
  visibility: hidden;
}

.originalPriceButton {
  text-decoration: line-through;
  opacity: 0.8;
  padding: @space-0 @space-2;
}

.salePriceButton {
  font-weight: 600;
}

.buttonContainer {
  flex: 0 0 auto;
  height: 48px;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.ctaButton {
  width: 100%;
}
